module.exports = __webpack_public_path__ + "img/Screens-2.6fa98373.png";